<template>
  <div class="port-listing">
    <vs-row class="mb-8">
      <vs-col vs-w="12">
        <div class="float-right flex">
          <vs-button
            color="warning"
            type="filled"
            class="btn-color"
            icon-pack="feather"
            icon="icon-filter"
            @click="showfilter = !showfilter"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="dark"
            type="filled"
            icon-pack="feather"
            icon="icon-upload"
            class="btn-color ml-4"
            @click.prevent="exportCsv()"
            >{{ $t("labels.export") }}</vs-button
          >
        </div>
      </vs-col>
    </vs-row>
    <vx-card class="filter-card mb-6" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            v-model="search"
            class="w-full"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3">
          <label class="pl-1">{{ $t("labels.country") }}</label>
          <v-select
            v-model="country"
            :options="filterCountries"
            :reduce="(filterCountries) => filterCountries.id"
            label="name"
            name="countries"
            class="filter-dropdown"
          />
        </div>
        <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
          <vs-button
            color="primary"
            type="filled"
            icon-pack="feather"
            icon="icon-filter"
            :title="$t('labels.filter')"
            @click.prevent="filter()"
            :disabled="!this.search && !this.country"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.filter") }}</vs-button
          >
          <vs-button
            color="maroon"
            type="filled"
            icon-pack="feather"
            icon="icon-x"
            :title="$t('labels.filter')"
            @click="clearFilter()"
            :disabled="!this.search && !this.country"
            class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn"
            >{{ $t("labels.clear") }}</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card :title="$t('labels.ports')" class="lead-listing">
      <div class="vx-row w-full m-0 list-header">
        <div
          class="vx-col sm: w-1/2 md:w-1/2 mb-4 set_limit pl-0 pr-0 justify-between"
        >
          <div class="set flex">
            <label class="limit_label">{{ $t("labels.show") }}</label>
            <v-select
              v-model="limit"
              :options="limitarr"
              :reduce="(limitarr) => limitarr.value"
              :clearable="false"
              label="text"
              class="px-1"
            />
            <label class="limit_label">{{ $t("labels.ports") }}</label>
          </div>
        </div>
        <div
          class="vx-col sm: w-1/2 md:w-1/2 pl-0 pr-0 justify-flex-end addbtn-col sm: mb-0 md:mb-6"
        >
          <router-link :to="{ name: 'AddPort' }">
            <vs-button
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              class="float-right btn-add sm: mb-6 md:m-0"
              v-if="checkPermission('ports', 'add')"
              >{{ $t("labels.add_port") }}</vs-button
            >
          </router-link>
        </div>
      </div>

      <vs-table :data="ports" class="permission">
        <template slot="thead">
          <!-- <vs-th>{{ $t('labels.serial_no') }}</vs-th> -->
          <vs-th class="col-md-5">{{ $t("labels.name") }}</vs-th>
          <vs-th class="col-md-5">{{ $t("labels.country") }}</vs-th>
          <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.name }}</vs-td>
            <vs-td>{{ tr.country.name }}</vs-td>
            <vs-td width="135">
              <div class="flex">
                <vs-button
                  type="flat"
                  :title="$t('labels.edit')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-edit"
                  color="success"
                  class="mr-2"
                  v-if="checkPermission('ports', 'modify')"
                  @click="
                    $router.push({ name: 'EditPort', params: { id: tr.id } })
                  "
                ></vs-button>
                <vs-button
                  @click="deleteConfirm(indextr)"
                  type="flat"
                  :title="$t('labels.delete')"
                  size="large"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  color="danger"
                  v-if="checkPermission('ports', 'delete')"
                >
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="mt-6">
        <vs-pagination
          color="dark"
          :total="totalPage"
          v-model="currentx"
          class="mb-1"
        ></vs-pagination>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ports: [],
      index: -1,
      totalPage: 1,
      country: 0,
      filterCountries: [],
      currentx: 1,
      limit: parseInt(process.env.VUE_APP_PER_PAGE),
      // limit: this.$store.state.limit,
      showfilter: false,
      search: null,
    };
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    this.getPorts();
    // this.getCountries();
  },
  watch: {
    showfilter(val) {
      if (val == true) {
        this.getCountries();
      }
    },
    limit(val) {
      // this.$store.state.limit = val
      localStorage.setItem("limit", val);
      this.currentx = 1;
      this.getPorts();
    },
    currentx(val) {
      this.getPorts();
    },
  },
  methods: {
    deleteConfirm(index) {
      this.index = index;
      this.$vs.dialog({
        type: "confirm",
        color: "rgba(var(--vs-primary),1)",
        title: this.$t("labels.confirmation"),
        acceptText: this.$t("labels.yes"),
        cancelText: this.$t("labels.no"),
        text: this.$t("strings.delete_confirm"),
        accept: this.deletePort,
      });
    },
    async deletePort() {
      if (this.index < 0) return;
      let url = "ports/delete";
      let ids = [];
      let index = this.index;
      ids.push(this.ports[index].id);
      let input = {
        ids: ids,
      };
      let response = await this.getHTTPPostResponse(url, input, null, true);
      if (response) {
        this.getPorts();
      }
    },
    async getPorts(exp = false) {
      let input = {
        page: this.currentx,
        perPage: this.limit,
        search: this.search,
        country_id: this.country,
      };
      if (exp) {
        input = Object.assign(
          {
            export: true,
          },
          input
        );
      }
      let response = await this.getHTTPPostResponse("/ports/list", input);
      if (exp) {
        this.exportFile(response, "Ports");
      }
      if (!exp) {
        if (response) {
          let data = response.data;
          let perPage = this.limit;
          let totalPage = Math.ceil(response.data.count / perPage);
          this.totalPage = totalPage;
          this.ports = data.ports;
        }
      }
    },
    async getCountries() {
      let input = {
        name: this.country,
      };
      let response = await this.getHTTPPostResponse("/country/list", input);
      if (response) {
        let data = response.data;
        this.filterCountries = data.countries;
      }
    },
    exportCsv() {
      this.getPorts(true);
    },
    filter() {
      this.getPorts();
    },
    clearFilter() {
      this.search = null;
      this.country = 0;
      this.getPorts();
    },
  },
};
</script>
